import { EditOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import {
  productStatusColors,
  productStatusLabels,
} from 'apps/catalog/constants/fundProduct';
import UIIconTooltip from 'common/ui/UIIconTooltip';
import { Link } from 'react-router-dom';
import { dateCell, linkCell, numberCell } from 'utils/cell-formatter';
import { formatISODate } from 'utils/formatDate';
import { cloudflareCdn } from 'utils/image';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/catalog/products/funds' }),
  },
  {
    accessorKey: 'code',
    header: 'Code',
  },
  {
    accessorKey: 'alias',
    header: 'Alias',
  },
  {
    accessorKey: 'logo',
    header: 'Logo',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const logoUrl = getValue();
      return logoUrl ? (
        <img
          src={cloudflareCdn(logoUrl, 80)}
          alt="Logo"
          className="w-16 rounded"
        />
      ) : (
        '-'
      );
    },
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    accessorKey: 'nav',
    header: 'Nav',
    cell: numberCell,
  },
  {
    accessorKey: 'nav_date',
    header: 'Nav date',
    cell: dateCell,
  },
  {
    accessorKey: 'fund_type_name',
    header: 'Fund Type',
    cell: ({ getValue, row }) => {
      const fundTypeName = getValue();
      const fundType = row.original.fund_type;
      return `${fundTypeName} (${fundType})`;
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const status = getValue();
      return (
        <Tag color={productStatusColors[status]}>
          {productStatusLabels[status]}
        </Tag>
      );
    },
  },
  {
    accessorKey: 'fund',
    header: 'Fund Manager',
    cell: ({ getValue, row }) => {
      const fund = getValue();
      const fallback = row.original.fund_manager;
      return fund ? `${fund.name} (${fund.code})` : fallback || '-';
    },
  },
  {
    accessorKey: 'risk_level',
    header: 'Risk level',
    cell: ({ getValue, row }) => {
      const value = getValue();
      const { risk_level_label } = row.original;
      return value ? risk_level_label || value : '-';
    },
  },
  {
    accessorKey: 'created_at',
    header: 'Created',
    cell: ({ getValue }) => formatISODate(getValue()),
  },
  {
    accessorKey: 'id',
    header: 'Action',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => (
      <Link to={`/catalog/products/funds/${getValue()}/edit`}>
        <UIIconTooltip title="Edit" Icon={EditOutlined} />
      </Link>
    ),
  },
];
